export default {
    direct: 'direct',
    channel: 'channel',
    privateGroup: 'privateGroup',
    publicGroup: 'publicGroup'
}